"use strict";

var PyDefUtils = require("PyDefUtils");

module.exports = function(pyModule, componentsModule) {

    pyModule["DesignRepeatingPanel"] = Sk.misceval.buildClass(pyModule, function($gbl, $loc) {

        $loc["_refresh_form"] = new Sk.builtin.func(function(self, instanceIndex) {
            var showError = function(message) {
                var pyC = Sk.misceval.callsimArray(pyModule["InvalidComponent"], [], ["text", new Sk.builtin.str(message)]);
                self._anvil.element.append(pyC._anvil.element);
            };

            var formName = self._anvil.templateFormName;

            if (!self._anvil.forms || !self._anvil.formInstanceIndex || formName == '' || formName == null) {
                return;
            }

            self._anvil.element.empty();

            var formContainer = null;
            let [, logicalDepId, className] = formName.match(/^(?:([^:]*):)?([^:]*)$/) || [];
            const depId = logicalDepId ? anvilAppDependencyIds[logicalDepId] : componentsModule.newPythonComponent.dependencyTrace?.depId;
            if (logicalDepId && !depId) {
                showError("Dependency missing: " + logicalDepId);
                return;
            }
            if (depId && !self._anvil.dependencies[depId]) {
                showError("Dependency missing: No such form '" + className + "'. Select a valid value for item_template.");
                return;
            }

            let qualifiedFormName = depId ? `${self._anvil.dependencies[depId].package_name}.${className}` : className;
            let forms = depId ? self._anvil.dependencies[depId].forms : self._anvil.forms;
            for (let f of forms) {
                if (f.class_name == className) {
                    var formContainer = $.extend({}, f.container);
                    formContainer.name = "";
                    formContainer.components = f.components;
                    var untouched = f.untouched;
                    break;
                }
            }


            if (!formContainer) {
                showError("No such form '" + className + "'. Select a valid value for item_template.");
                return;
            }

            for (var t = componentsModule.newPythonComponent.formTrace; t; t = t.prev) {
                if (t.name == formName) {
                    showError("Cannot nest form '" + formName + "' inside itself");
                    return;
                }
            }
            
            let instanceId = self._anvil.parentForm.name + "." + self._anvil.componentSpec.name;

            if (!instanceIndex) {
                instanceIndex = {};
            }

            var nRepeats = instanceIndex[instanceId] ? 1 : 3;
            instanceIndex[instanceId] = true;
            for (var i = 0; i < nRepeats; i++) {

                var componentsByName = {};
                //componentsModule.newPythonComponent.formTrace = {name: formName};
                var pyFormContainer = Sk.misceval.retryOptionalSuspensionOrThrow(
                    componentsModule.withDependencyTrace(depId, () =>
                        componentsModule.withFormTrace(formName, function() {
                            return componentsModule.newPythonComponent(formContainer, componentsByName, null, {}, self._anvil.formInstanceIndex, null, self._anvil.forms, self._anvil.dependencies, instanceIndex);
                        })
                    )
                );

                pyFormContainer._anvil.isForm = true;
                pyFormContainer._anvil.componentsByName = componentsByName;
                self._anvil.formInstanceIndex[formName] = self._anvil.formInstanceIndex[formName] || [];
                self._anvil.formInstanceIndex[formName].push(pyFormContainer);

                PyDefUtils.pyCall(self._anvil.addComponent, [pyFormContainer]);
                self._anvil.element.append(pyFormContainer._anvil.element);

                if (i == 0) {
                    if(untouched) {
                        self._anvil.element.prepend($("<div/>").addClass("anvil-designer-repeating-panel-edit-prompt").text("Double-click here to edit item template"));
                    } else if (!(pyFormContainer instanceof pyModule["DataRowPanel"])) {
                        pyFormContainer._anvil.element.prepend($("<div/>").addClass("anvil-designer-repeating-panel-drop-prompt").text("Drop components here"));
                    }
                    self._anvil.componentsByName = componentsByName;
                    pyFormContainer._anvil.element.addClass("anvil-designer-namespace-region");
                } else {
                    pyFormContainer._anvil.element.addClass("anvil-designer-no-hit");
                    pyFormContainer._anvil.element.addClass("anvil-designer-hide-if-nested");
                    pyFormContainer._anvil.element.css({
                        opacity: 0.7 - (0.7*((i-1)/(nRepeats-1))),
                    })
                }

            }

        });

        $loc["__init__"] = new Sk.builtin.func(PyDefUtils.withRawKwargs(function(kwargs, self) {

            Sk.misceval.call(pyModule["RepeatingPanel"].prototype["__init__"], undefined, undefined, kwargs, self);
            self._anvil.element.append("RepeatingPanel: Set the item_template property to begin.");
            self._anvil.addComponent = self._anvil.pyHiddenContainer.tp$getattr(new Sk.builtin.str("add_component"));

        }));

    }, 'DesignRepeatingPanel', [pyModule["RepeatingPanel"]]);
};
